// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
    border-radius: 7px;
    height: 40px;
    border: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 500;
    max-width: 205px;
    width: 100%;
    cursor: pointer;
    letter-spacing: 0.1px;
}

.outlined {
    background-color: white;
    color: rgba(63, 113, 236, 0.6);
    font-weight: 600!important;
    border: 1px solid rgba(63, 113, 236, 0.6);
}

@media (max-width:450px){
    .btn {
        border-radius: 7px;
        height: 40px;
        border: 0;
        font-family: 'Montserrat', sans-serif;
        font-size: 13px !important;
        font-weight: 500;
        max-width: 500px;
        width: 100%;
        cursor: pointer;
        letter-spacing: 0.1px;
    }
}

.btn_full {
    border-radius: 7px;
    height: 40px;
    border: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    cursor: pointer;
    margin-top: 30px;
}

@media (max-width: 400px){
    .btn_full {
    border-radius: 7px;
    height: 40px;
    border: 0;
        font-family: 'Montserrat', sans-serif;
    font-size: 11px;
    font-weight: 500;
    width: 100%;
    cursor: pointer;
    margin-top: 30px;
    }
}

.icon {
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn_icon {
    margin-right: 7px;
}
.btn_icon:hover {
    cursor: pointer;
}

.add-person {
    max-width: 205px;
    margin-left: auto;
}

.btn_round {
    height: 38px;
    width: 38px;
    min-width: 38px;
    min-height: 38px;
    border: 0px;
    border-radius: 50%;
    text-align: center;
    display: inline-block;
    vertical-align: bottom;
    box-shadow: 0 3px 6px rgba(178, 178, 178, 0.16);
    cursor: pointer;
}

.btn_round img {
    margin-top: 7px;
}

.h-39 {
    height: 39px;
    padding: 0;
}

button:disabled,
button[disabled]{
    opacity: 0.3;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Buttons/Button.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,qCAAqC;QACrC,0BAA0B;QAC1B,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,qBAAqB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;IACA,kBAAkB;IAClB,YAAY;IACZ,SAAS;QACL,qCAAqC;IACzC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".btn {\n    border-radius: 7px;\n    height: 40px;\n    border: 0;\n    font-family: 'Montserrat', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    max-width: 205px;\n    width: 100%;\n    cursor: pointer;\n    letter-spacing: 0.1px;\n}\n\n.outlined {\n    background-color: white;\n    color: rgba(63, 113, 236, 0.6);\n    font-weight: 600!important;\n    border: 1px solid rgba(63, 113, 236, 0.6);\n}\n\n@media (max-width:450px){\n    .btn {\n        border-radius: 7px;\n        height: 40px;\n        border: 0;\n        font-family: 'Montserrat', sans-serif;\n        font-size: 13px !important;\n        font-weight: 500;\n        max-width: 500px;\n        width: 100%;\n        cursor: pointer;\n        letter-spacing: 0.1px;\n    }\n}\n\n.btn_full {\n    border-radius: 7px;\n    height: 40px;\n    border: 0;\n    font-family: 'Montserrat', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    width: 100%;\n    cursor: pointer;\n    margin-top: 30px;\n}\n\n@media (max-width: 400px){\n    .btn_full {\n    border-radius: 7px;\n    height: 40px;\n    border: 0;\n        font-family: 'Montserrat', sans-serif;\n    font-size: 11px;\n    font-weight: 500;\n    width: 100%;\n    cursor: pointer;\n    margin-top: 30px;\n    }\n}\n\n.icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.btn_icon {\n    margin-right: 7px;\n}\n.btn_icon:hover {\n    cursor: pointer;\n}\n\n.add-person {\n    max-width: 205px;\n    margin-left: auto;\n}\n\n.btn_round {\n    height: 38px;\n    width: 38px;\n    min-width: 38px;\n    min-height: 38px;\n    border: 0px;\n    border-radius: 50%;\n    text-align: center;\n    display: inline-block;\n    vertical-align: bottom;\n    box-shadow: 0 3px 6px rgba(178, 178, 178, 0.16);\n    cursor: pointer;\n}\n\n.btn_round img {\n    margin-top: 7px;\n}\n\n.h-39 {\n    height: 39px;\n    padding: 0;\n}\n\nbutton:disabled,\nbutton[disabled]{\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
